"use client"

import { ComponentConfig, DropZone } from "@measured/puck"

import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { convertCSSEditMode, generateResponsiveCSS } from "../../lib/helper"

export interface ContainerProps extends CommonStylesProps {
  type: "fluid" | "custom" | "boxed"
}

export const RenderConfig: ComponentConfig<ContainerProps> = {
  render: ({ type, className, styles, responsiveType, animation, editMode, puck }) => {
    const width = type === "fluid" ? "w-full max-w-full" : ``
    // Generate a unique ID for the component for dynamic CSS scoping
    const id = `box-${Math.random().toString(36).substr(2, 9)}`
    // Generate responsive CSS
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const convertedCSSEditMode = styles && convertCSSEditMode(styles)

    const desktopCSSEditMode = convertedCSSEditMode?.desktop
    const mobileCSSEditMode = convertedCSSEditMode?.mobile

    return (
      <>
        {editMode ?? responsiveCSS}
        {/* {responsiveCSS} */}
        <div
          id={id}
          data-aos={editMode ?? animation?.["data-aos"]}
          data-aos-duration={editMode ?? animation?.["data-aos-duration"]}
          className={twMerge("container mx-auto", width, `${id} ${className}`)}
        >
          <DropZone zone="item" style={editMode ? (desktopCSSEditMode as React.CSSProperties) : {}} />
        </div>
      </>
    )
  },
}
